import type React from "react";

import { useSelector, useDispatch } from "react-redux";

import { allTrackers } from "app/services/track/track";

import { resetSuppressionListErrors } from "../../../store/actions/suppressionListActions";
import { parseListThunk } from "../../../store/effects/parsing";
import {
    selectHasListOwnedByCurrentUser,
    selectIsLoadingLists,
    selectIsSLHasError,
    selectParsingErrors,
} from "../../../store/selectors/suppressionListSelectors";
import type { CompanyParsingErrors } from "../../types";

import { UploadCSV } from "./UploadCSV";

export const LoadListView = () => {
    const dispatch = useDispatch();

    const isReplace = useSelector(selectHasListOwnedByCurrentUser);
    const isLoading = useSelector(selectIsLoadingLists);
    const hasParsingError = useSelector(selectIsSLHasError);

    const parsingErrors: CompanyParsingErrors = useSelector(selectParsingErrors);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const csvFile = event?.target?.files?.[0];
        dispatch(resetSuppressionListErrors());

        if (csvFile) {
            const parsedDomains = await dispatch(parseListThunk(csvFile));
            if (parsedDomains) {
                const action = isReplace ? "replace" : "upload";
                allTrackers.dispatchTrackEvent("suppression", `${action} list`, `account suppression/${action}`);
            }
        }
    };

    return (
        <UploadCSV
            isLoading={isLoading}
            isReplace={isReplace}
            handleFileChange={handleFileChange}
            hasParsingError={hasParsingError}
            parsingErrors={parsingErrors}
            className="withBoxShadow"
        />
    );
};
